import { currentUserSelector } from "Auth/state";
import { IUser } from "Auth/types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { FormBuilder } from "shared/components";
import { API_ENDPOINTS } from "shared/constants";
import { getFields, VenueExtraFormFieldsProps } from "./formData";

export interface VenueExtraFormProps extends VenueExtraFormFieldsProps {
  defaultValues?: Record<string, any>;
}

export const VenueExtraForm: React.FC<VenueExtraFormProps> = ({
  defaultValues,
  handleBandsChange,
  ...props
}) => {
  const { id: currentUserId } = useSelector(currentUserSelector) as IUser;

  useEffect(() => {
    const bands = defaultValues?.bands as string[];
    if (!bands?.length) return;

    handleBandsChange(
      defaultValues?.bands ? bands.map((id) => API_ENDPOINTS.BAND(id)) : null
    );
  }, [defaultValues?.bands, handleBandsChange]);

  return (
    <FormBuilder
      fields={getFields({
        ...props,
        currentUserId,
        handleBandsChange,
      })}
      defaultValues={defaultValues}
      onSubmit={() => {}} // values are captured on change
    />
  );
};
